/** Curated itinerary list labels (shared by landing UI, persona pages, and itinerary state). */
export const PERSONA_DISPLAY: Record<string, { name: string; description: string; guideUrl?: string }> = {
  'family-day': {
    name: 'Families',
    description: 'The Market is well known for having “something for everyone,” and that definitely includes families with kids! Our compact size makes the Market very walking- and stroller-friendly, and there are plenty of shaded places to sit down in between adventures. Here are our recommended sites to visit that provide colorful fun and engagement for youthful senses.',
    guideUrl: 'https://farmersmarketla.com/pages/plan-your-itinerary---families-edition'
  },
  foodie: {
    name: 'Foodies',
    description: 'Fancy yourself a flavor adventurer, a bit of a gourmand? Perfect! In addition to “classic American” eateries assembled over our 90+ year history, the Market’s merchants serve up a cornucopia of new and multicultural ingredients and prepared dishes to intrigue your palate.',
    guideUrl: 'https://farmersmarketla.com/pages/plan-your-itinerary---foodie-edition'
  },
  'date-night': {
    name: 'Date Night',
    description: 'Out for an evening of romance with a significant other? Stroll the Market (hand in hand) and sample some of our suggestions for a memorable made-in-LA date night.',
    guideUrl: 'https://farmersmarketla.com/pages/plan-your-itinerary---date-night-edition'
  }
};

/** Default saved title for an itinerary started from a curated list (`sourceList` id). */
export function defaultNameForPersonaListId(listId: string): string {
  const entry = PERSONA_DISPLAY[listId];
  if (entry?.name?.trim()) {
    return entry.name.trim();
  }
  return listId;
}
